import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-promotion-post-form',
  templateUrl: './promotion-post-form.component.html',
  styleUrls: ['./promotion-post-form.component.css']
})
export class PromotionPostFormComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/hrms/Promotions/promotions-post/promotion-post-form/promotion-post-form.component.ts